
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --outline-admin-links--color--computed:var(--outline-admin-links--color, var(--outline-gray-600));
  --outline-admin-links--color-hover--computed:var(--outline-admin-links--color-hover, var(--outline-soft-black));
  --outline-admin-links--color-focus--computed:var(--outline-admin-links--color-focus, var(--outline-soft-black));
  --outline-admin-links--color-active--computed:var(--outline-admin-links--color-active,var( --outline-white));
  --outline-admin-links--bg--computed:var(--outline-admin-links--bg, var(--outline-gray-100));
  --outline-admin-links--bg-hover--computed:var(--outline-admin-links--bg-hover,var( --outline-gray-300));
  --outline-admin-links--bg-focus--computed:var(--outline-admin-links--bg-focus,var( --outline-gray-300));
  --outline-admin-links--bg-active--computed:var(--outline-admin-links--bg-active, var(--outline-blue-600));
  --outline-admin-links--spacing-y--computed:var(--outline-admin-links--spacing-y, var(--spacing-4));
  --outline-admin-links--link-spacing-y--computed:var(--outline-admin-links--link-spacing-y, var(--spacing-4));
  --outline-admin-links--link-spacing-x--computed:var(--outline-admin-links--link-spacing-x, var(--spacing-6));
}

.links{
  padding-top:var(--outline-admin-links--spacing-y--computed);
  padding-bottom:var(--outline-admin-links--spacing-y--computed);
}

ul{
  display:flex;
  list-style-type:none;
  margin:0;
  overflow-x:scroll;
  overflow-y:hidden;
  padding:0;
  white-space:nowrap;
  -webkit-overflow-scrolling:touch;
  -ms-overflow-style:-ms-autohiding-scrollbar;
}

@media (min-width: 1024px){

ul{
    overflow-x:initial;
    overflow-y:initial;
    white-space:normal
}
  }

ul::-webkit-scrollbar{
    display:none;
  }

li{
  margin:0;
  padding:0;
  display:block;
}

a{
  display:block;
  position:relative;
  text-decoration:none;
  padding-top:var(--outline-admin-links--link-spacing-y--computed);
  padding-bottom:var(--outline-admin-links--link-spacing-y--computed);
  padding-left:var(--outline-admin-links--link-spacing-x--computed);
  padding-right:var(--outline-admin-links--link-spacing-x--computed);
  background:var(--outline-admin-links--bg--computed);
  color:var(--outline-admin-links--color--computed);
}

a:hover{
    outline:none;
    background:var(--outline-admin-links--bg-hover--computed);
    color:var(--outline-admin-links--color-hover--computed);
  }

a:focus{
    outline:none;
    background:var(--outline-admin-links--bg-focus--computed);
    color:var(--outline-admin-links--color-focus--computed);
  }

a:not(.is-active):hover::before,
  a:not(.is-active):focus::before{
    position:absolute;
    top:50%;
    left:50%;
    width:calc(100%);
    height:100%;
    content:'';
    transform:translate(-50%, -50%);
    border:solid 2px var(--outline-admin-links--color-hover--computed);
    border-radius:0.25rem;
  }

a.is-active{
    outline:solid 2px var(--outline-admin-links--color-hover--computed);
    background:var(--outline-admin-links--bg-active--computed);
    color:var(--outline-admin-links--color-active--computed);
    z-index:1;
  }

a.is-active:hover,
    a.is-active:focus{
      outline-offset:2px;
    }
`;